export const DEFAULT_TERMS_CONTENT = {
  title: 'Notice: System Usage & Security Policy',
  description: 'To protect platform stability and intellectual property:',
  terms: [
    {
      heading: 'Individual Access Only',
      body: 'Credentials are strictly assigned to single individual users. Multi-user login sharing is prohibited.',
    },
    {
      heading: 'Automated Access Strictly Prohibited',
      body: 'Automated scraping, bot access, scripting, or reverse engineering of platform APIs and interfaces is prohibited.',
    },
    {
      heading: 'Rate Limiting & Security Monitoring',
      body: 'Accounts exhibiting anomalous traffic volumes or automated behavior will be automatically suspended pending security review.',
    },
  ],
  acknowledgementLabel: 'I acknowledge and agree to the Acceptable Use Terms.',
};

export const normalizeTermsContent = (apiData) => {
  if (!apiData || typeof apiData !== 'object') {
    return DEFAULT_TERMS_CONTENT;
  }

  const terms = Array.isArray(apiData.terms)
    ? apiData.terms
      .filter(
        (term) => term
            && typeof term.heading === 'string'
            && term.heading.trim() !== ''
            && typeof term.body === 'string'
            && term.body.trim() !== '',
      )
      .map((term) => ({
        heading: term.heading.trim(),
        body: term.body.trim(),
      }))
    : [];

  const title = typeof apiData.title === 'string' && apiData.title.trim() !== ''
    ? apiData.title.trim()
    : DEFAULT_TERMS_CONTENT.title;

  const description = typeof apiData.description === 'string' && apiData.description.trim() !== ''
    ? apiData.description.trim()
    : DEFAULT_TERMS_CONTENT.description;

  const acknowledgementLabel = typeof apiData.acknowledgementLabel === 'string'
    && apiData.acknowledgementLabel.trim() !== ''
    ? apiData.acknowledgementLabel.trim()
    : DEFAULT_TERMS_CONTENT.acknowledgementLabel;

  if (terms.length === 0) {
    return {
      title,
      description,
      terms: DEFAULT_TERMS_CONTENT.terms,
      acknowledgementLabel,
    };
  }

  return {
    title,
    description,
    terms,
    acknowledgementLabel,
  };
};
